import type { QueryKey } from '@tanstack/react-query'
import type { QueryParams } from '@opallabs/api'

export const queryKeys = {
  services: (query?: QueryParams): QueryKey =>
    query ? ['week-view', 'services', { query }] : ['week-view', 'services'],
  byServiceId: (id: string, query?: QueryParams): QueryKey => [
    ...queryKeys.services(query),
    id,
  ],
}
